import api from ".";

export const personalSheetsCrud = (data, method, callBack) => {
    const path = data?.id ? `/sheets/${data.id}/` : data?.page ? `/sheets/?page=${data?.page}` : '/sheets/';

    const payload = { ...data };
    if (method !== 'get') {
        delete payload.id;
    }

    const config = method === 'get' && !data?.id ? { params: data } : payload;

    api[method](path, config)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const sharedSheetsCrud = (data, method, callBack) => {
    const path = data?.id ? `/sheets/shared/${data.id}/` : data?.page ? `/sheets/shared/?page=${data?.page}` : '/sheets/shared/';

    const payload = { ...data };
    if (method !== 'get') {
        delete payload.id;
    }

    const config = method === 'get' && !data?.id ? { params: data } : payload;

    api[method](path, config)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const dacr = (data, callBack) => {
    api.post(`/dacr-formula/`, data)
        .then((response) => {
            callBack(response);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const hideSheetRowsAndCols = (sheetId, data, callBack) => {
    api.put(`/sheets/${sheetId}/protection/`, data)
        .then((response) => {
            callBack(response);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};


